import {
    cilLockLocked,
    cilSpeedometer,
    cilUser,
    cibGmail,
    cilCheckCircle,
    cilCircle,
    cilPencil,
    cilBan,
    cilReload,
    cilTrash,
    cilMenu,
    cilPuzzle,
    cilObjectGroup,
    cilFile,
    cilArrowBottom,
    cilArrowTop,
} from '@coreui/icons'

const icons = {
    cilLockLocked,
    cilSpeedometer,
    cilUser,
    cibGmail,
    cilCheckCircle,
    cilCircle,
    cilPencil,
    cilBan,
    cilReload,
    cilTrash,
    cilMenu,
    cilPuzzle,
    cilObjectGroup,
    cilFile,
    cilArrowBottom,
    cilArrowTop,
};

export default icons;
